import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private isloggedIn: boolean;
  private isLogInDisclaimerReq: string;

  constructor(private router: Router) {
    this.isLogInDisclaimerReq = undefined;
    if (sessionStorage.getItem('applicationProperties') != undefined)
      this.isLogInDisclaimerReq = JSON.parse(sessionStorage.getItem('applicationProperties'))['LOGINDISCLAIMER'];
    this.isloggedIn =
      sessionStorage.getItem('isLoggedIn') == null
        ? false
        : sessionStorage.getItem('isLoggedIn') == undefined
        ? false
        : sessionStorage.getItem('isLoggedIn') == 'true'
        ? this.isLogInDisclaimerReq == undefined || this.isLogInDisclaimerReq == 'NO'
          ? true
          : this.isLogInDisclaimerReq == 'YES' &&
            sessionStorage.getItem('isDisclaimerInSession') != undefined &&
            sessionStorage.getItem('isDisclaimerInSession') == 'YES'
          ? true
          : false
        : false;
    // console.log(this.isloggedIn)
  }

  setLoggedInSession() {
    this.isloggedIn = true;
    sessionStorage.setItem('isLoggedIn', 'true');
    // console.log(this.isloggedIn)
    return this.isloggedIn;
  }

  // isUserLoggedIn(): boolean {
  //   this.isloggedIn =
  //     sessionStorage.getItem('isLoggedIn') == null
  //       ? false
  //       : sessionStorage.getItem('isLoggedIn') == undefined
  //       ? false
  //       : sessionStorage.getItem('isLoggedIn') == 'true'
  //       ? true
  //       : false;
  //   return this.isloggedIn;
  // }
  isUserLoggedIn(): boolean {
    this.isloggedIn =
      sessionStorage.getItem('isLoggedIn') == null
        ? false
        : sessionStorage.getItem('isLoggedIn') == undefined
        ? false
        : sessionStorage.getItem('isLoggedIn') == 'true'
        ? this.isLogInDisclaimerReq == undefined || this.isLogInDisclaimerReq == 'NO'
          ? true
          : this.isLogInDisclaimerReq == 'YES' &&
            sessionStorage.getItem('isDisclaimerInSession') != undefined &&
            sessionStorage.getItem('isDisclaimerInSession') == 'YES'
          ? true
          : false
        : false;
    return this.isloggedIn;
  }

  isRouteAuthorized(routeUrl: any): boolean {
    let isRouteAuthorized = true;
    let authorizationExternalUrl = undefined;
    if (sessionStorage.getItem('applicationProperties') != undefined) {
      authorizationExternalUrl = JSON.parse(sessionStorage.getItem('applicationProperties'))[
        'AUTHORIZEEXTERNAL_URL'
      ];
    }
    if (authorizationExternalUrl != undefined && authorizationExternalUrl == 'YES') {
      isRouteAuthorized = false;
      let userLoginData = undefined;
      if (sessionStorage.getItem('userLoginData') != undefined) {
        userLoginData = JSON.parse(sessionStorage.getItem('userLoginData'));
      }

      if (userLoginData != undefined) {
        userLoginData['menuResourceUrlList'].forEach((menuResourceUrl) => {
          if (menuResourceUrl == '/' + routeUrl || menuResourceUrl.indexOf('/*' + routeUrl) > -1)
            isRouteAuthorized = true;
        });
      }
    }
    return isRouteAuthorized;
  }

  isMenuHidden(): boolean {
    return sessionStorage.getItem('isMenuHidden') == null
      ? false
      : sessionStorage.getItem('isMenuHidden') == undefined
      ? false
      : sessionStorage.getItem('isMenuHidden') == 'true'
      ? true
      : false;
  }

  logoutUser(): void {
    sessionStorage.clear();
    // console.log(this.isloggedIn)
    this.isloggedIn = false;
    this.router.navigate(['login']);
  }

  setDisclaimerInSession(): void {
    sessionStorage.setItem('isDisclaimerInSession', 'YES');
  }
}
